export default {
  common: {
    appName: 'ElderCare',
    loading: 'Carregando...',
    retry: 'Tentar novamente',
    goBack: 'Início',
    logout: 'Sair',
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Excluir',
    edit: 'Editar',
    search: 'Pesquisar',
    weekDays: {
      sun: 'Dom',
      mon: 'Seg',
      tue: 'Ter',
      wed: 'Qua',
      thu: 'Qui',
      fri: 'Sex',
      sat: 'Sáb',
    },
  },
  nav: {
    home: 'Início',
    login: 'Entrar',
    dashboard: 'Painel',
    health: 'Saúde',
    medication: 'Medicamentos',
    sos: 'Emergência',
    family: 'Família',
    article: 'Artigos',
    checkin: 'Check-in',
    settings: 'Configurações',
    about: 'Sobre',
  },
  footer: {
    rights: 'Todos os direitos reservados',
    privacy: 'Política de privacidade',
    terms: 'Termos de serviço',
  },
  index: {
    hero: {
      title: 'ElderCare - Guardião inteligente de saúde para idosos',
      subtitle: 'Plataforma de gestão de saúde projetada para idosos, mantendo as famílias informadas e os idosos saudáveis',
      cta: 'Começar',
      learnMore: 'Saiba mais',
    },
    features: {
      title: 'Funcionalidades principais',
      health: { title: 'Monitoramento de saúde', desc: 'Registre pressão arterial, glicemia e frequência cardíaca com alertas inteligentes' },
      medication: { title: 'Gestão de medicamentos', desc: 'Lembretes e verificação de interações medicamentosas, nunca mais esqueça uma dose' },
      sos: { title: 'Chamada de emergência', desc: 'SOS com um toque, notificação automática da família e compartilhamento de localização' },
      family: { title: 'Cuidado familiar', desc: 'Monitoramento remoto, alertas instantâneos e compartilhamento de dados para famílias' },
      article: { title: 'Artigos de saúde', desc: 'Conhecimentos de saúde confiáveis e guias de bem-estar personalizados' },
      checkin: { title: 'Check-in diário', desc: 'Acompanhamento diário simples para construir hábitos saudáveis' },
    },
    elderly: {
      title: 'Design para idosos',
      desc: 'Projetado para idosos: fácil de usar, ver e tocar',
      font: 'Fontes grandes',
      touch: 'Áreas de toque amplas',
      contrast: 'Cores de alto contraste',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Entrar',
    registerTab: 'Registrar',
    name: 'Nome',
    email: 'Email',
    password: 'Senha',
    role: 'Eu sou',
    elderRole: 'Idoso',
    familyRole: 'Familiar',
    bindCode: 'Código de vinculação',
    bindCodeHint: 'Insira o código de vinculação da conta do idoso para associar e visualizar os dados de saúde',
    loginBtn: 'Entrar',
    registerBtn: 'Registrar',
    verifyHint: 'Um email de verificação será enviado ao seu endereço após o registro',
    error: 'Operação falhou, tente novamente',
    nameTooShort: 'O nome deve ter pelo menos 2 caracteres',
    emailInvalid: 'Insira um endereço de e-mail válido',
    passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
  },
  dashboard: {
    title: 'Painel de saúde',
    metrics: {
      bloodPressure: 'Pressão arterial',
      bloodSugar: 'Glicemia',
      heartRate: 'Frequência cardíaca',
      weight: 'Peso',
      sleep: 'Sono',
      temperature: 'Temperatura',
    },
    quickActions: 'Ações rápidas',
    recordHealth: 'Registrar saúde',
    takeMedicine: 'Tomar remédio',
    sos: 'Chamada de emergência',
    checkinStatus: 'Check-in de hoje',
    checkedIn: 'Registrado hoje',
    notCheckedIn: 'Não registrado hoje',
    goCheckin: 'Registrar',
    medicationReminders: 'Lembretes de medicamentos',
    noReminders: 'Nenhum lembrete de medicamentos',
    taken: 'Tomado',
  },
  health: {
    title: 'Registros de saúde',
    inputTitle: 'Entrada de dados',
    systolic: 'Sistólica (mmHg)',
    diastolic: 'Diastólica (mmHg)',
    bloodSugar: 'Glicemia (mmol/L)',
    heartRate: 'Frequência cardíaca (bpm)',
    weight: 'Peso (kg)',
    sleepHours: 'Sono (horas)',
    temperature: 'Temperatura (°C)',
    submit: 'Enviar registro',
    trend: 'Tendências',
    days: 'dias',
    aiAnalysis: 'Análise de saúde por IA',
    analyze: 'Analisar',
    noAnalysis: 'Clique no botão acima para obter um relatório de análise de saúde por IA',
    history: 'Histórico',
    noHistory: 'Nenhum histórico',
    chartLabelSystolic: 'Pressão sistólica',
  },
  medication: {
    title: 'Gestão de medicamentos',
    currentPlan: 'Plano atual',
    noMedications: 'Nenhum medicamento',
    addMedication: 'Adicionar medicamento',
    name: 'Nome do medicamento',
    dosage: 'Dosagem',
    frequency: 'Frequência',
    freqDaily: 'Uma vez ao dia',
    freqTwice: 'Duas vezes ao dia',
    freqThree: 'Três vezes ao dia',
    freqWeekly: 'Uma vez por semana',
    time: 'Horário de toma',
    startDate: 'Data de início',
    addBtn: 'Adicionar',
    interactionWarning: 'Alerta de interação medicamentosa',
    noInteraction: 'Nenhum risco de interação medicamentosa',
    calendar: 'Calendário de medicamentos',
    invalidTimeFormat: 'Formato de hora inválido, use HH:mm (ex., 08:00, 20:00)',
  },
  sos: {
    title: 'Chamada de emergência',
    holdToCall: 'Segurar para chamar',
    holdHint: 'Segure por 1 segundo para ativar a chamada de emergência',
    sent: 'Chamada de emergência enviada',
    sentDesc: 'Seus contatos de emergência foram notificados. Mantenha a calma e aguarde ajuda',
    contacts: 'Contatos de emergência',
    location: 'Localização atual',
    loadingLocation: 'Obtendo localização...',
    locationUnavailable: 'Localização indisponível',
    history: 'Histórico SOS',
    noHistory: 'Nenhum registro SOS',
    confirmed: 'Confirmado',
    pending: 'Pendente',
    sendFailed: 'Falha ao enviar alerta de emergência, tente novamente',
    resolved: 'Resolvido',
  },
  family: {
    title: 'Cuidado familiar',
    members: 'Família vinculada',
    noMembers: 'Nenhum familiar vinculado',
    bindCode: 'Código de vinculação',
    bindCodeHint: 'Compartilhe este código com familiares para vincular as contas',
    invite: 'Convidar familiar',
    email: 'Email do familiar',
    relationship: 'Relação',
    relSon: 'Filho',
    relDaughter: 'Filha',
    relSpouse: 'Cônjuge',
    relSibling: 'Irmão/Irmã',
    relOther: 'Outro',
    inviteBtn: 'Enviar convite',
    notifications: 'Preferências de notificação',
    prefAbnormal: 'Alerta de anomalia sanitária',
    prefMedication: 'Lembrete de medicamentos',
    prefSos: 'Alerta de emergência',
    prefWeekly: 'Relatório semanal',
    prefCheckin: 'Notificação de check-in',
    dataSharing: 'Compartilhamento de dados',
    shareDesc: 'Permitir que a família visualize seus dados de saúde',
  },
  article: {
    title: 'Artigos de saúde',
    search: 'Pesquisar artigos...',
    noArticles: 'Nenhum artigo encontrado',
    expand: 'Ler mais',
    collapse: 'Recolher',
    categories: {
      all: 'Todos',
      heart: 'Cardiovascular',
      diabetes: 'Diabetes',
      bone: 'Ossos',
      sleep: 'Sono',
      nutrition: 'Nutrição',
      exercise: 'Exercício',
    },
  },
  checkin: {
    title: 'Check-in diário',
    feeling: 'Como se sente hoje?',
    feelings: {
      great: 'Ótimo',
      good: 'Bem',
      normal: 'Normal',
      bad: 'Mal',
      terrible: 'Péssimo',
    },
    medication: 'Medicamentos hoje',
    yes: 'Sim',
    no: 'Não',
    diet: 'Avaliação da dieta',
    dietRatings: {
      good: 'Boa',
      normal: 'Normal',
      poor: 'Ruim',
    },
    exercise: 'Exercício hoje',
    mood: 'Humor',
    submit: 'Enviar check-in',
    streak: 'Sequência',
    streakDays: 'dias',
    calendar: 'Calendário de check-in',
  },
  settings: {
    title: 'Configurações',
    profile: 'Perfil',
    name: 'Nome de usuário',
    phone: 'Telefone',
    birthday: 'Data de nascimento',
    emergencyContact: 'Contato de emergência',
    save: 'Salvar alterações',
    preferences: 'Preferências',
    language: 'Idioma',
    theme: 'Tema',
    light: 'Claro',
    dark: 'Escuro',
    notifications: 'Notificações',
    notifHealth: 'Alertas de saúde',
    notifMedication: 'Lembretes de medicamentos',
    notifSos: 'Alertas de emergência',
    notifCheckin: 'Lembretes de check-in',
    bindCode: 'Meu código de vinculação',
    changePassword: 'Alterar senha',
    currentPassword: 'Senha atual',
    newPassword: 'Nova senha',
    changePasswordBtn: 'Alterar senha',
    dangerZone: 'Zona de perigo',
    deleteDesc: 'A exclusão da conta é irreversível. Todos os dados serão perdidos',
    deleteAccount: 'Excluir conta',
    deleteConfirm: 'Tem certeza? Esta ação não pode ser desfeita!',
  },
  about: {
    title: 'Sobre o ElderCare',
    subtitle: 'Guardião inteligente de saúde para idosos',
    intro: 'Introdução',
    introContent: 'ElderCare é uma plataforma de gestão de saúde projetada para idosos, com monitoramento inteligente, gestão de medicamentos, chamadas de emergência e muito mais, para ajudar os idosos a gerenciar sua saúde mantendo-se conectados com a família.',
    version: 'Informações da versão',
    versionNumber: 'Número da versão',
    buildDate: 'Data de compilação',
    acknowledgements: 'Agradecimentos',
    contact: 'Contato',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Política de privacidade',
    terms: 'Termos de serviço',
  },
  notfound: {
    message: 'Desculpe, a página que você acessou não existe',
    goHome: 'Voltar ao início',
  },
  privacy: {
    title: 'Política de privacidade',
    sections: {
      collection: {
        title: 'Coleta de informações',
        content: 'Coletamos apenas as informações pessoais necessárias para fornecer nossos serviços, incluindo dados de registro (email, nome), dados de saúde (pressão arterial, glicemia e outros indicadores) e informações do dispositivo. Não coletamos nenhuma informação pessoal não relacionada aos nossos serviços.',
      },
      usage: {
        title: 'Uso das informações',
        content: 'Suas informações pessoais são usadas exclusivamente para fornecer e melhorar nossos serviços, incluindo análise de dados de saúde, alertas de anomalias, lembretes de medicamentos e outras funcionalidades essenciais. Não usaremos suas informações para fins não autorizados.',
      },
      storage: {
        title: 'Armazenamento de informações',
        content: 'Seus dados são armazenados em servidores na nuvem seguros com transmissão e armazenamento criptografados. Adotamos medidas técnicas razoáveis para proteger a segurança dos seus dados e impedir acessos não autorizados.',
      },
      sharing: {
        title: 'Compartilhamento de informações',
        content: 'Sem seu consentimento explícito, não compartilharemos suas informações pessoais com terceiros. Os dados de saúde serão compartilhados com familiares vinculados somente após sua autorização de conexão familiar.',
      },
      rights: {
        title: 'Seus direitos',
        content: 'Você tem o direito de acessar, corrigir e excluir suas informações pessoais, bem como de retirar seu consentimento. Pode exercer esses direitos através das configurações do aplicativo ou contatando nossa equipe de suporte.',
      },
      security: {
        title: 'Segurança',
        content: 'Utilizamos criptografia e medidas de segurança em conformidade com os padrões do setor para proteger seus dados, incluindo transmissão criptografada SSL, armazenamento criptografado de dados e controle de acesso. Revisamos e atualizamos regularmente nossas medidas de segurança.',
      },
    },
  },
  terms: {
    title: 'Termos de serviço',
    sections: {
      acceptance: {
        title: 'Aceitação dos termos',
        content: 'Ao usar este aplicativo, você concorda em cumprir os presentes termos de serviço. Se não concordar com qualquer parte destes termos, por favor pare de usar este aplicativo. Reservamo-nos o direito de modificar estes termos a qualquer momento.',
      },
      service: {
        title: 'Descrição do serviço',
        content: 'ElderCare fornece serviços de assistência à gestão de saúde, incluindo registro de dados de saúde, lembretes de medicamentos, chamadas de emergência e outras funcionalidades. Este serviço é apenas para referência e não constitui aconselhamento médico, nem pode substituir serviços médicos profissionais.',
      },
      accounts: {
        title: 'Gestão de contas',
        content: 'É necessário registrar uma conta para usar as funcionalidades essenciais deste aplicativo. Você é responsável pela segurança da sua senha e por todas as atividades realizadas em sua conta. Se detectar uso não autorizado da sua conta, notifique-nos imediatamente.',
      },
      data: {
        title: 'Dados e privacidade',
        content: 'Valorizamos a proteção da sua privacidade. Para regras detalhadas de tratamento de dados, consulte nossa Política de privacidade. Você mantém controle total sobre os dados de saúde que envia.',
      },
      liability: {
        title: 'Limitação de responsabilidade',
        content: 'As informações de saúde fornecidas por este aplicativo são apenas para referência e não constituem diagnóstico ou conselho de tratamento médico. Não somos responsáveis por quaisquer perdas resultantes do uso das informações deste aplicativo. Em caso de problemas de saúde, consulte um profissional de saúde qualificado.',
      },
      changes: {
        title: 'Alterações dos termos',
        content: 'Podemos atualizar estes termos de serviço periodicamente. Alterações significativas serão comunicadas através de notificações no aplicativo ou por email. O uso continuado deste aplicativo constitui aceitação dos termos atualizados.',
      },
    },
  },
  feedback: {
    title: 'Feedback',
    subtitle: 'Seu feedback é muito importante para nós',
    name: 'Nome',
    namePlaceholder: 'Digite seu nome (opcional)',
    email: 'E-mail',
    emailPlaceholder: 'Digite seu e-mail',
    subject: 'Assunto',
    subjectGeneral: 'Feedback geral',
    subjectBug: 'Relatório de bug',
    subjectFeature: 'Sugestão de recurso',
    subjectOther: 'Outro',
    message: 'Mensagem',
    messagePlaceholder: 'Descreva seu feedback em detalhes...',
    submit: 'Enviar feedback',
    submitting: 'Enviando...',
    success: 'Feedback enviado com sucesso! Obrigado pela sua contribuição',
    error: 'Falha ao enviar feedback, tente novamente mais tarde',
  },
  verify: {
    loading: 'Verificando seu e-mail...',
    success: 'Verificação bem-sucedida!',
    successDesc: 'Seu e-mail foi verificado. Agora você pode fazer login',
    failed: 'Falha na verificação',
    failedDesc: 'O link de verificação é inválido ou expirou. Reenvie o e-mail de verificação',
    resend: 'Reenviar e-mail de verificação',
    resending: 'Enviando...',
    goLogin: 'Ir para login',
  },
  theme: {
    light: 'Claro',
    dark: 'Escuro',
  },
}
